var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _path8, _path9, _circle, _path10, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 36 36",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4AB88",
    d: "M15.898 34.875h-1.365s-1.27-3.348-1.074-5.736l2.801.549c.526 1.571-.362 5.187-.362 5.187zm4.144 0h1.365s1.27-3.348 1.074-5.736l-2.801.549c-.526 1.571.362 5.187.362 5.187z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA743E",
    d: "M13.792 35.149c.102-.243.318-.694.341-.955c.023-.261.034-.354.24-.426c.347-.121 1.436-.087 1.623-.016c.186.071.189.263.216.424s.114.424.227.64c.114.216.409.697.261 1.034c-.062.14-.405.138-1.507.138s-1.417-.026-1.492-.118s-.011-.477.091-.721zm8.356 0c-.102-.243-.318-.694-.341-.955c-.023-.261-.034-.354-.24-.426c-.347-.121-1.436-.087-1.623-.016c-.187.071-.189.263-.216.424s-.114.424-.227.64s-.409.697-.261 1.034c.062.14.405.138 1.507.138c1.102 0 1.417-.026 1.492-.118s.011-.477-.091-.721z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4AB88",
    d: "M8.646 4.146c.011.127.871 1.535 1.323 2.635c.452 1.1.71 2.198.948 2.448c.476.499 2.092 1.879 3.117 3.343s.724 2.503.06 2.922c-.88.555-1.803.204-2.437-.788a154.058 154.058 0 0 1-2.739-4.601A22.5 22.5 0 0 1 7.7 7.531c-.397-1-.444-2.168-.504-2.312c-.174-.425-1.12-.977-1.154-1.407c0 0 2.567-.095 2.604.334zm18.708 0c-.011.127-.871 1.535-1.323 2.635c-.452 1.1-.71 2.198-.948 2.448c-.476.499-2.092 1.879-3.117 3.343s-.724 2.503-.06 2.922c.88.555 1.803.204 2.437-.788c.451-.706 1.951-3.209 2.739-4.601a22.76 22.76 0 0 0 1.217-2.573c.397-1 .444-2.168.504-2.312c.175-.425 1.121-.977 1.155-1.406c0-.002-2.567-.097-2.604.332z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M36 3.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1 0-1h35a.5.5 0 0 1 .5.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M34 0a1 1 0 0 0-1 1a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1zM4 0a1 1 0 0 0-1 1a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA743E",
    d: "M22.172 12.286c-.742.419-1.283 1.257-1.492 1.617c-.665.117-1.151.3-1.151.3H16.47s-.486-.183-1.151-.3c-.209-.36-.75-1.197-1.492-1.617c0 0-2.121.937-2.746 1.521c.21.537.492 1.047.716 1.417c.4 1.092 1.502 2.527 1.626 2.777c.389.78.741 4.5.741 4.5L18 24l3.835-1.5s.352-3.72.741-4.5c.125-.25 1.227-1.685 1.626-2.777c.224-.37.506-.879.716-1.417c-.625-.583-2.746-1.52-2.746-1.52z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D4AB88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.096 4.363c-.33-.157-.476-.428-.377-.719l.003-.01c.099-.291.291-.346.738-.339c0 0 1.521.076 2.437.712c0 0-.456.304-.699.56v.01c-.185.541-1.894-.115-2.102-.214z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.843 3.47a.257.257 0 0 1-.188-.31l.087-.357c.033-.137.173-.221.31-.188s.221.173.188.31l-.087.357a.258.258 0 0 1-.31.188zm-.445-.87a.315.315 0 0 0-.397.197l-.279.837c-.055.164.168-.068.332-.013a.314.314 0 0 0 .397-.196l.144-.427a.316.316 0 0 0-.197-.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.384 3.399a.257.257 0 0 1-.188-.31l.082-.334c.033-.137.173-.221.31-.188s.221.173.188.31l-.082.334a.258.258 0 0 1-.31.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 3.424a.257.257 0 0 1-.188-.31l.068-.277c.033-.137.173-.221.31-.188s.221.173.188.31l-.068.277a.258.258 0 0 1-.31.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.419 3.447a.257.257 0 0 1-.188-.31l.04-.162c.033-.137.173-.221.31-.188s.221.173.188.31l-.04.162a.257.257 0 0 1-.31.188z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#D4AB88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.904 4.363c.33-.157.476-.428.377-.719l-.003-.01c-.099-.29-.291-.346-.738-.339c0 0-1.521.076-2.437.712c0 0 .454.314.702.57c.098.29 1.362.137 2.099-.214z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.157 3.47a.257.257 0 0 0 .188-.31l-.087-.357a.257.257 0 0 0-.31-.188a.258.258 0 0 0-.188.31l.087.357a.258.258 0 0 0 .31.188zm.445-.87a.315.315 0 0 1 .397.197l.279.837c.055.164-.168-.068-.332-.013a.314.314 0 0 1-.397-.196l-.144-.427a.316.316 0 0 1 .197-.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.616 3.399a.257.257 0 0 0 .188-.31l-.082-.334a.257.257 0 0 0-.31-.188a.257.257 0 0 0-.187.31l.082.334a.256.256 0 0 0 .309.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 3.424a.257.257 0 0 0 .188-.31l-.068-.277a.256.256 0 1 0-.497.122l.068.277a.256.256 0 0 0 .309.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.581 3.447a.257.257 0 0 0 .188-.31l-.039-.162a.258.258 0 0 0-.31-.188a.258.258 0 0 0-.188.31l.04.162a.256.256 0 0 0 .309.188z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD551F",
    d: "M21.84 24.5L18 23l-3.84 1.5s-.82 1.917-.96 5.188h3.06c.88-.979 1.2-3.604 1.2-3.604h1.08s.32 2.625 1.2 3.604h3.06c-.14-3.271-.96-5.188-.96-5.188z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M14.136 22.5h7.729v2h-7.729z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#14171A",
    d: "M19 22.399h.65v2.209H19z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 18.5,
    cy: 23.458,
    r: 0.167
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#14171A",
    d: "M18.021 23.458a.167.167 0 0 1-.334 0a.167.167 0 0 1 .334 0z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 17.208,
    cy: 23.458,
    r: 0.167
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 16.562,
    cy: 23.458,
    r: 0.167
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 15.917,
    cy: 23.458,
    r: 0.167
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 15.271,
    cy: 23.458,
    r: 0.167
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 14.625,
    cy: 23.458,
    r: 0.167
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 17.208,
    cy: 23.458,
    r: 0.167
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#657786",
    cx: 16.553,
    cy: 23.458,
    r: 0.148
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#657786",
    d: "M16.318 23.31h.235v.297h-.235z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#657786",
    d: "M16.729 24.846h-.758v-2.697h.758v.35h-.409v1.997h.409z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#963B22",
    d: "M19.591 3.84c-.823-.266-2.758-.194-3.242.436c-1.258.024-2.734 1.161-2.928 2.661c-.192 1.485.235 2.174.387 3.291c.172 1.265.883 1.669 1.452 1.839c.818 1.081 1.688 1.034 3.147 1.034c2.851 0 4.209-1.908 4.329-5.148c.073-1.96-1.077-3.444-3.145-4.113z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4AB88",
    d: "M16.778 12.286v2.444a1.222 1.222 0 1 0 2.444 0v-2.444h-2.444z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4AB88",
    d: "M21.221 8.091c-.276-.382-.629-.69-1.403-.798c.29.133.569.593.605.847c.036.254.073.46-.157.206c-.921-1.018-1.924-.617-2.917-1.239c-.694-.434-.905-.915-.905-.915s-.085.641-1.137 1.294c-.305.189-.669.611-.871 1.234c-.145.448-.1.847-.1 1.529c0 1.991 1.641 3.666 3.666 3.666s3.666-1.689 3.666-3.666c-.002-1.238-.132-1.722-.447-2.158z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M19.629 12.286h-3.258s.407.814 1.629.814s1.629-.814 1.629-.814zm-1.222-1.019h-.815a.204.204 0 1 1 0-.408h.815a.204.204 0 1 1 0 .408z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M16.371 9.842a.407.407 0 0 1-.407-.407v-.408a.407.407 0 1 1 .814 0v.407a.407.407 0 0 1-.407.408zm3.258 0a.407.407 0 0 1-.407-.407v-.408a.407.407 0 1 1 .814 0v.407a.407.407 0 0 1-.407.408z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.df2a4a0461359c650ae1e36bd259feaf.svg";
export { ForwardRef as ReactComponent };